export default __webpack_public_path__ + "static/media/chart3.cf9a53d5.svg";